import Swal from 'sweetalert2';
import { useStateContext } from '../context/AuthContext';

const httpErrors = {
    400: 'Solicitação inválida - A requisição possui sintaxe inválida.',
    401: 'Não autorizado - Falha na autenticação ou falta de autorização.',
    403: 'Acesso proibido - O servidor entende a requisição, mas recusa cumpri-la.',
    404: 'Não encontrado - O recurso solicitado não foi encontrado.',
    422: 'Ops - O recurso solicitado não foi encontrado.',
    500: 'Erro interno do servidor - O servidor encontrou uma situação que não sabe como lidar.',
    // Adicione outros códigos e mensagens conforme necessário
};

export const errorMessage = (error) => {
    if (error.response && error.response.status && httpErrors[error.response.status]) {
        const { statusText, data: { message } } = error.response;
        if (message) {
            const hasSQLSTATE = message.includes('SQLSTATE');
            if (hasSQLSTATE) {
                console.clear();
                return { statusText, message: 'Erro de comunicação com o banco de dados. Tente novamente mais tarde.' };
            }
            return { statusText, message };
        } else if (httpErrors[error.response.status]) {
            return { statusText, message: httpErrors[error.response.status] };
        }
    } else {
        return {
            statusText: 'Internal Server Error',
            message: error
        };
    }
}

export const ErrorMessage = (error) => {

    const { setUser, user } = useStateContext();

    if (error.response && error.response.status && httpErrors[error.response.status]) {
        const { statusText, data: { message } } = error.response;
        if (message) {
            return Swal.fire({
                title: statusText,
                text: message,
                icon: 'error'
            });
        } else if (httpErrors[error.response.status]) {
            return Swal.fire({
                title: statusText,
                text: httpErrors[error.response.status],
                icon: 'error'
            });
        }
    } else {
        setUser({
            ...user, 
            permissions: []
        })
        return Swal.fire({
            title: 'Internal Server Error',
            text: error,
            icon: 'error'
        });
    }
}